import { LogLevel } from "@azure/msal-browser";
import { getConfigValue } from "../config/runtimeConfig";

const clientId = getConfigValue("REACT_APP_CLIENT_ID");
const tenantName = getConfigValue("REACT_APP_TENANT_NAME");
const signInSignUpPolicy = getConfigValue("REACT_APP_SIGNIN_SIGNUP_POLICY");
const passwordResetPolicy = getConfigValue("REACT_APP_PASSWORD_RESET_POLICY");
const redirectUri = getConfigValue("REACT_APP_REDIRECT_URI");
const clientSecret = getConfigValue("REACT_APP_CLIENT_SECRET_CODE");

const msalConfig = {
  auth: {
    clientId,
    authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${signInSignUpPolicy}`, // Authority for sign-in/sign-up
    knownAuthorities: [`${tenantName}.b2clogin.com`],
    redirectUri, // Redirect URI
    postLogoutRedirectUri: "/",
    clientSecret,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  // system: {
  //   loggerOptions: {
  //     loggerCallback: (level, message, containsPii) => {
  //       if (containsPii) {
  //         return;
  //       }
  //       switch (level) {
  //         case LogLevel.Error:
  //           console.error(message);
  //           return;
  //         case LogLevel.Info:
  //           console.info(message);
  //           return;
  //         case LogLevel.Verbose:
  //           console.debug(message);
  //           return;
  //         case LogLevel.Warning:
  //           console.warn(message);
  //           return;
  //       }
  //     },
  //   },
  // },
};

const loginRequest = {
  scopes: ["openid", "profile",],
};

const passwordResetAuthority = `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${passwordResetPolicy}`;

export { msalConfig, loginRequest, passwordResetAuthority };
